module.exports = __webpack_public_path__ + "img/skyline.87c01b2a.jpeg";